import type { DynamicClient, WalletAccount } from '@dynamic-labs-sdk/client';
import { getActiveNetworkData } from '@dynamic-labs-sdk/client';

type GetActiveNetworkClusterParams = {
  walletAccount: WalletAccount;
};

export const getActiveNetworkCluster = async (
  { walletAccount }: GetActiveNetworkClusterParams,
  client: DynamicClient
): Promise<`solana:${string}` | undefined> => {
  const { networkData } = await getActiveNetworkData({ walletAccount }, client);

  if (!networkData?.cluster) {
    return;
  }

  return `solana:${networkData.cluster}`;
};
